import React, { useEffect, useReducer, useState } from 'react';
import cn from 'classnames';

// DEBUG MODULES
import { Panes, TestPanes } from './Modules';

// MANAGERS
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getDebugTools, setDebugTools } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';

// CSS
import styles from '@UILayer/UILayer.scss';

// TYPES
import { IDebugState, ITabNames } from './DebugTools.types';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

// COMPONENTS
import { Tabs, Sliders } from '@UILayer/Inputs/Tabs';
import { PhaserPerformanceSimple } from './Modules/PhaserStatus/PhaserStatus.performance.simple';

const DebugTools: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: {}, newState: IDebugState) => ({ ...state, ...newState }), {
        panelShow: false,
        activeTab: ITabNames.TEST,
        appVersion: process.env.VERSION,
        visible: true
    });

    const [focusedIdx, setFocusedIdx] = useState<number>(0);
    const [focusedIdx2, setFocusedIdx2] = useState<number>(0);

    const dispatch = useAppDispatch();
    const debugTools = useAppSelector(getDebugTools);

    const containerCN = cn(styles.debug_tools_container, state.panelShow ? styles.active : styles.inactive);

    useEffect(() => {
        Logger.log(LoggerLevel.UseEffect, { component: 'DebugTools', message: 'REACT :: MODULE :: DEBUG TOOLS', source: LoggerSource.React });

        setState({ visible: true, panelShow: false });
        setTimeout(() => {
            setState({ panelShow: debugTools });
        }, 250);
    }, [debugTools]);

    function togglePanel(tab: ITabNames) {
        setState({ activeTab: tab });
    }

    function closePanel() {
        dispatch(setDebugTools(false));

        setTimeout(() => {
            setState({ visible: false });
        }, 250);
    }

    return (
        <>
            {state.visible && (
                <div className={containerCN}>
                    <div>
                        <div className={styles.debug_tools_main_tab}>
                            <div className={cn(state.activeTab === ITabNames.TEST && styles.active)} onPointerDown={() => togglePanel(ITabNames.TEST)}>
                                Test
                            </div>
                            <div className={cn(state.activeTab === ITabNames.INFO && styles.active)} onPointerDown={() => togglePanel(ITabNames.INFO)}>
                                Info
                            </div>

                            <div className={styles.closeBtn} onPointerDown={() => closePanel()}>
                                X
                            </div>
                        </div>
                        <div className={styles.debug_tools_wrapper}>
                            {state.activeTab === ITabNames.INFO && (
                                <>
                                    <div className={styles.debug_tools_sub_tabs_container}>
                                        <Tabs className={styles.debug_tools_sub_tabs} focusedIdx={focusedIdx} tabs={Panes} onChange={setFocusedIdx} />
                                    </div>
                                    <div className={styles.debug_tools_sub_wrapper}>
                                        <Sliders focusedIdx={focusedIdx} slides={Panes} />
                                    </div>
                                </>
                            )}
                            {state.activeTab === ITabNames.TEST && (
                                <>
                                    <div className={styles.debug_tools_sub_tabs_container}>
                                        <Tabs className={styles.debug_tools_sub_tabs} focusedIdx={focusedIdx2} tabs={TestPanes} onChange={setFocusedIdx2} />
                                    </div>
                                    <div className={styles.debug_tools_sub_wrapper}>
                                        <Sliders focusedIdx={focusedIdx2} slides={TestPanes} />
                                    </div>
                                </>
                            )}
                            <div className={styles.debug_tools_footer}>APP version: {state.appVersion}</div>
                        </div>
                    </div>
                </div>
            )}
            <PhaserPerformanceSimple />
        </>
    );
};

export default DebugTools;
